const initTableScroll = () => {
  const $tables = $('.table');
  const scrolledTableClass = 'table--scrolled';

  $tables.each(function () {
    const $table = $(this);
    const $tableScrollElement = $table.find('.table__scroll-wrap');
    let tableWidth = $tableScrollElement.innerWidth();
    let tableScrollWidth = $tableScrollElement.prop('scrollWidth');
    const hasLeftScroll = !!$table.find('.table__actions-wrap-left').length
    const scrollHandler = hasLeftScroll ? initTableScrollLeft : initTableScrollRight

    scrollHandler();
    $tableScrollElement.on('scroll', scrollHandler);

    $(window).on('resize', function () {
      tableWidth = $tableScrollElement.innerWidth();
      tableScrollWidth = $tableScrollElement.prop('scrollWidth');
      scrollHandler();
    });

    function initTableScrollRight() {
      const currentScrollLeft = $tableScrollElement.scrollLeft();

      if (currentScrollLeft >= tableScrollWidth - tableWidth) $table.removeClass(scrolledTableClass);
      else if (tableScrollWidth > tableWidth) $table.addClass(scrolledTableClass);
    }

    function initTableScrollLeft() {
      const currentScrollLeft = $tableScrollElement.scrollLeft();

      if (currentScrollLeft === 0) $table.removeClass(scrolledTableClass);
      else $table.addClass(scrolledTableClass);
    }
  });
}

export default initTableScroll